import React, { useEffect } from "react";
import { Button, Form, Input, DatePicker, Select, TreeSelect } from "antd";
import { useModel } from "../../../models/index";

const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: false, message: '请选择制单时间!' }],
};
export default function () {
    const [form] = Form.useForm();

    const [{ supplierDict }] = useModel("cmDict");

    const [{ searchParam, searcnPage }, { setSearchParam, resetSearchParam, loadListDetail }] = useModel("supplierModel");

    /*useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam]);*/

    useEffect(() => {
        onReset();
    }, []);


    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { supplierName } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum, 
            supplierName,
        }
        loadListDetail({ showMsg: true, data });
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();
        let data = {
            pageSize: 15,
            pageNum: 1,
        }
        loadListDetail({ showMsg: true, data })
    }
    return (
        <Form
            form={form}
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            {/* <Form.Item
                name="supplierName"
                label="供应商名称"
            >
                <Input placeholder="供应商名称" style={{ width: "200px" }} />
            </Form.Item> */}
            <Form.Item
                name="supplierName"
                label="供应商名称"
            >
                <Select
                    style={{ width: "200px" }}
                    showSearch
                    allowClear={true}
                    placeholder="选择供应商"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={supplierDict}
                    dropdownClassName="dark-select"
                />
            </Form.Item>
            <Form.Item name="checkTime" label="结算日期" {...rangeConfig}>
                <RangePicker style={{ width: "300px" }} />
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="button"
                            className="margin-left-8"
                            onClick={onReset}
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}